/**
 * Outreach Campaigns API – uses SNS Intel's shared axios instance.
 * All endpoints hit /api/outreach/campaigns (admin-only).
 */
import api from '../../../api';
import type {
  Campaign,
  CampaignListResponse,
  CampaignCreate,
  CampaignUpdate,
  DashboardStats,
} from '../types';

const PREFIX = '/api/outreach/campaigns';

export const outreachCampaignsApi = {
  list: async (params: {
    page?: number;
    page_size?: number;
    is_active?: boolean;
    brand?: string;
    /** When true, returns only soft-deleted campaigns (audit view). Defaults to false. */
    deleted?: boolean;
  }): Promise<CampaignListResponse> => {
    const { data } = await api.get<CampaignListResponse>(PREFIX, { params });
    return data;
  },

  get: async (campaignId: string): Promise<Campaign> => {
    const { data } = await api.get<Campaign>(`${PREFIX}/${campaignId}`);
    return data;
  },

  create: async (campaign: CampaignCreate): Promise<Campaign> => {
    const { data } = await api.post<Campaign>(PREFIX, campaign);
    return data;
  },

  update: async (campaignId: string, update: CampaignUpdate): Promise<Campaign> => {
    const { data } = await api.patch<Campaign>(`${PREFIX}/${campaignId}`, update);
    return data;
  },

  delete: async (campaignId: string): Promise<Campaign> => {
    const { data } = await api.delete<Campaign>(`${PREFIX}/${campaignId}`);
    return data;
  },

  dashboardStats: async (): Promise<DashboardStats> => {
    const { data } = await api.get<DashboardStats>(`${PREFIX}/stats/dashboard`);
    return data;
  },
};
